import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Text } from "../UI";
import { Item, renderKeyValue } from "./Common";
import EditImg from "../asserts/img/edit_doc.svg";

import DeleteImg from "../asserts/img/delete_doc.svg";

const ExpDetailMobileRow = ({
  exp,
  keys,
  handelRowDeleteClick,
  handelRowClick,
}) => {
  const { t } = useTranslation("month_reports");

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        flexDirection: "column",
        borderBottom: `1px solid #D9D9D9`,
        paddingBottom: 14,
      }}>
      <div
        style={{
          display: "flex",
          gap: 20,
          width: "100%",
          alignItems: "center",
          flex: 1,
          padding: 15,
          paddingBottom: 5,
        }}>
        <Text
          style={{
            color: "#293041",
            fontSize: 16,
            fontWeight: 500,
          }}>
          {exp.EXTFILEDES}
        </Text>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginInlineStart: "auto",
          }}>
          <IconButton
            src={EditImg}
            iconSize={18}
            label={t("common:edit")}
            style={{ margin: "-13px 0" }}
            onClick={(e) => handelRowClick(e, exp)}
          />
          <IconButton
            src={DeleteImg}
            iconSize={18}
            label={t("common:delete")}
            style={{ margin: "-13px 0" }}
            onClick={(e) => handelRowDeleteClick(e, exp)}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          padding: 20,
          paddingTop: 0,
          paddingBottom: 10,
          width: "100%",
        }}>
        {keys.map((key) => (
          <Item
            label={t(key.key)}
            value={renderKeyValue(key, exp)}
            width={"50%"}
          />
        ))}
      </div>
    </div>
  );
};

export default ExpDetailMobileRow;
